/**
 * Canvas equivalent of WeekDayIcon.jsx — coloured pie slices per active weekday.
 * Shares the same DAY_COLORS palette used by the SVG component.
 */
import { generatePieIcon } from './generatePieIcon'

export const DAY_COLORS = {
  Sunday: '#F97316',
  Monday: '#E879F9',
  Tuesday: '#A78BFA',
  Wednesday: '#34D399',
  Thursday: '#FB7185',
  Friday: '#FBBF24',
  Saturday: '#60A5FA',
}

/**
 * @param {string[]} weekDays  - Active day names, e.g. ['Monday', 'Wednesday', 'Friday']
 * @param {object}   opts      - Forwarded to generatePieIcon (size, borderWidth, borderColor)
 * @returns {HTMLCanvasElement}
 */
export function generateWeekDayIcon(weekDays, opts = {}) {
  const colors = (weekDays || []).map(d => DAY_COLORS[d] || '#888888')
  return generatePieIcon(colors, { size: 24, borderWidth: 1, borderColor: '#333333', ...opts })
}

export function generateWeekDayIconUrl(weekDays, opts = {}) {
  return generateWeekDayIcon(weekDays, opts).toDataURL()
}
